import { SimpleGrid } from "@chakra-ui/react";
import ComparePeriodFilter from "./ComparePeriodFilter";
import CurrencyFilter from "./CurrencyFilter";
import GroupByFilter from "./GroupByFilter";
import PeriodFilter from "./PeriodFilter";

const PrimaryFilters = ({
  currentGroupByOptions,
  currentPeriodOptions,
  currentPeriods,
  filters,
  handleApplyFilters,
  isRTL,
  t,
}) => (
  <SimpleGrid columns={{ base: 1, sm: 2, xl: 4 }} spacing={3}>
    <CurrencyFilter handleApplyFilters={handleApplyFilters} filters={filters} isRTL={isRTL} t={t} />
    <PeriodFilter handleApplyFilters={handleApplyFilters} currentPeriods={currentPeriods} filters={filters} isRTL={isRTL} t={t} />
    <ComparePeriodFilter currentPeriodOptions={currentPeriodOptions} handleApplyFilters={handleApplyFilters} filters={filters} isRTL={isRTL} />
    <GroupByFilter currentGroupByOptions={currentGroupByOptions} handleApplyFilters={handleApplyFilters} filters={filters} isRTL={isRTL} />
  </SimpleGrid>
);

export default PrimaryFilters;
